import { render, staticRenderFns } from "./Vales.vue?vue&type=template&id=826d0be2&"
import script from "./Vales.vue?vue&type=script&lang=js&"
export * from "./Vales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports